import React from "react";
import { Lock } from "lucide-react";

export const PayPalCardNote = ({ testid }) => (
  <p data-testid={testid} className="mt-2 flex items-start gap-2 font-mono text-[10px] uppercase leading-relaxed tracking-[0.16em] text-ink/70">
    <Lock size={12} className="mt-0.5 shrink-0" />
    Paying by credit or debit card? Tap the PayPal button. A secure PayPal window opens where you can pay by card as a guest, no PayPal account needed.
  </p>
);
